/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Delete from './Delete/index'
import Description from './Description/index'
import Edit from './Edit/index'
import Icons from './Icons/index'
import Number from './Number/index'
import React from 'react'
import Related from './Related/index'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone/Phones/Content/Phone"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Phone.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Icons
  viewPath={`${viewPath}/Icons`}
/>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
<div
  data-testid="Phone.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Related
  viewPath={`${viewPath}/Related`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}